import { IconAngleUp, IconSort } from '@iwoca/icons';
import { Header, flexRender } from '@tanstack/react-table';
import { Filter } from '../Filter/Filter';
import { TIntroducerListItem } from '../UsersTable.types';
import styles from './TableHeader.module.css';

type TProps = {
  header: Header<TIntroducerListItem, unknown>;
};

export const TableHeader = ({ header }: TProps) => {
  const { column } = header;
  const sortState = column.getIsSorted();
  const headerText = flexRender(column.columnDef.header, header.getContext());

  const renderSortButton = () => {
    const renderIcon = () => {
      if (sortState === 'asc') return <IconAngleUp width={16} />;
      if (sortState === 'desc')
        return <IconAngleUp className={styles.downIcon} width={16} />;
      return <IconSort width={16} />;
    };

    return (
      <button
        className={styles.sortButton}
        aria-label={`Sort by ${String(column.columnDef.header)}`}
        onClick={column.getToggleSortingHandler()}
      >
        {renderIcon()}
      </button>
    );
  };

  if (!column.getCanSort() && !column.getCanFilter()) {
    return <span className={styles.headerText}>{headerText}</span>;
  }

  return (
    <div className={styles.headerContainer}>
      <span className={styles.headerText}>{headerText}</span>
      <div className={styles.buttonsContainer}>
        {column.getCanSort() && renderSortButton()}
        {column.getCanFilter() && <Filter column={column} />}
      </div>
    </div>
  );
};
